// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#mail-content[data-v-170d5636] {\n\theight: 450px;\n}\n", ""]);
// Exports
module.exports = exports;
